module.exports = __webpack_public_path__ + "img/loader.73990b93.gif";